import { useContext } from 'react'
import { Context } from '../../context/Context';
import MainNav from '../Navbar/MainNav';
import Avatar from '../../assets/images/avatar.jpg';
import '../../assets/css/User.css'
import Footer from '../footer/Footer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const User = () => {
    const PF = "https://heroblog-api.onrender.com/images/"
    const { user } = useContext(Context);

  return (
    <div className='controll__footer'>
    <MainNav />
    <div className='user__profile__wrapper'>
      <Container>
        <Row>
          <Col>
            <h2>Author Profile</h2>
            <div className='user__info__wrapper'>
               <div className='user__info__left'>
                  {user?.profilePic !== "" ? 
                      <img src={PF+user?.profilePic}
                      width="175" height="175" /> : <img src={Avatar} width="175" height="175" alt="" />
                  }
                <h3>{user?.username}</h3>
                </div>
                <div className='user__info__right'>
                  <p>{user?.bio}</p>
                </div>
            </div>
          
            {/* <img src={PF + user?.profilePic}  alt=""/> */}
           
          </Col>
        </Row>
      </Container>
    </div>
      <Footer />
</div>
  )
}

export default User
